export enum IndicatorOrganisationSortOptions {
  Title_A_Z = 1,
  Title_Z_A = 2,
  Trend_Status_Red_Grey = 3,
  Trend_Status_Green_Grey = 4,
}
